/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmailDto } from './EmailDto';
import {
    EmailDtoFromJSON,
    EmailDtoFromJSONTyped,
    EmailDtoToJSON,
} from './EmailDto';
import type { TelephoneDto } from './TelephoneDto';
import {
    TelephoneDtoFromJSON,
    TelephoneDtoFromJSONTyped,
    TelephoneDtoToJSON,
} from './TelephoneDto';

/**
 * 
 * @export
 * @interface ChefEntrepriseDoublonSiegeSocialDto
 */
export interface ChefEntrepriseDoublonSiegeSocialDto {
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    idchefEntrepriseSiege?: number;
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    denominationSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    numeroBce?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    fonction?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    sortieEntreprise?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    chefEntreprisePrincipal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    remarqueSiege?: string | null;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    telephone?: TelephoneDto;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    gsm?: TelephoneDto;
    /**
     * 
     * @type {EmailDto}
     * @memberof ChefEntrepriseDoublonSiegeSocialDto
     */
    email?: EmailDto;
}

/**
 * Check if a given object implements the ChefEntrepriseDoublonSiegeSocialDto interface.
 */
export function instanceOfChefEntrepriseDoublonSiegeSocialDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefEntrepriseDoublonSiegeSocialDtoFromJSON(json: any): ChefEntrepriseDoublonSiegeSocialDto {
    return ChefEntrepriseDoublonSiegeSocialDtoFromJSONTyped(json, false);
}

export function ChefEntrepriseDoublonSiegeSocialDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefEntrepriseDoublonSiegeSocialDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idchefEntrepriseSiege': !exists(json, 'idchefEntrepriseSiege') ? undefined : json['idchefEntrepriseSiege'],
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'denominationSociale': !exists(json, 'denominationSociale') ? undefined : json['denominationSociale'],
        'numeroBce': !exists(json, 'numeroBce') ? undefined : json['numeroBce'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'fonction': !exists(json, 'fonction') ? undefined : json['fonction'],
        'sortieEntreprise': !exists(json, 'sortieEntreprise') ? undefined : (json['sortieEntreprise'] === null ? null : new Date(json['sortieEntreprise'])),
        'chefEntreprisePrincipal': !exists(json, 'chefEntreprisePrincipal') ? undefined : json['chefEntreprisePrincipal'],
        'remarqueSiege': !exists(json, 'remarqueSiege') ? undefined : json['remarqueSiege'],
        'telephone': !exists(json, 'telephone') ? undefined : TelephoneDtoFromJSON(json['telephone']),
        'gsm': !exists(json, 'gsm') ? undefined : TelephoneDtoFromJSON(json['gsm']),
        'email': !exists(json, 'email') ? undefined : EmailDtoFromJSON(json['email']),
    };
}

export function ChefEntrepriseDoublonSiegeSocialDtoToJSON(value?: ChefEntrepriseDoublonSiegeSocialDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idchefEntrepriseSiege': value.idchefEntrepriseSiege,
        'idsiegeSocial': value.idsiegeSocial,
        'denominationSociale': value.denominationSociale,
        'numeroBce': value.numeroBce,
        'actif': value.actif,
        'fonction': value.fonction,
        'sortieEntreprise': value.sortieEntreprise === undefined ? undefined : (value.sortieEntreprise === null ? null : value.sortieEntreprise.toISOString()),
        'chefEntreprisePrincipal': value.chefEntreprisePrincipal,
        'remarqueSiege': value.remarqueSiege,
        'telephone': TelephoneDtoToJSON(value.telephone),
        'gsm': TelephoneDtoToJSON(value.gsm),
        'email': EmailDtoToJSON(value.email),
    };
}

